module.exports = __webpack_public_path__ + "assets/img/4da8-ls.svg";